import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { STATS, MEDIA } from "@/lib/media";
import { Reveal, Counter, ImageReveal } from "./Reveal";

export default function WhyDogs() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-40, 80]);

  return (
    <section id="whyus" ref={ref} className="relative bg-ink py-24 md:py-40 border-t border-white/10" data-testid="why-us">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative h-[520px] hidden lg:block">
            <motion.div style={{ y: y1 }} className="absolute top-0 left-0 w-[62%] h-[75%] border border-white/10">
              <ImageReveal src={MEDIA.interior} alt="Luxury home interior" className="w-full h-full" />
            </motion.div>
            <motion.div style={{ y: y2 }} className="absolute bottom-0 right-0 w-[52%] h-[62%] border border-gold/30">
              <ImageReveal src={MEDIA.aerial} alt="Aerial roof survey" className="w-full h-full" />
            </motion.div>
          </div>

          <div>
            <Reveal>
              <span className="font-serif italic text-gold tracking-[0.25em] text-sm">Why Home Point Inspection, Inc</span>
              <h2 className="font-display uppercase text-cream leading-[0.9] tracking-tight text-5xl md:text-7xl mt-4">
                The Full <br /> Picture
              </h2>
              <p className="text-cream/60 mt-6 leading-relaxed text-lg max-w-lg">
                Buying a home is one of life's biggest decisions. We pair seasoned, certified
                inspectors with the latest <span className="text-gold">industry-proven technology</span> to
                give you a clear picture of the property. Our reports and expertise provide knowledge and
                certainty when making your decision.
              </p>
            </Reveal>

            <div className="grid grid-cols-2 gap-px bg-white/10 mt-12 border border-white/10">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={i * 0.1} className="bg-ink p-8">
                  <div className="font-display text-gold text-5xl md:text-6xl tracking-tight">
                    {s.text ? s.text : <Counter value={s.value} suffix={s.suffix} />}
                  </div>
                  <p className="text-cream/50 text-sm mt-3 leading-snug">{s.label}</p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
